import { AIPDATA_BASE_URL } from '../../ApiConfig';
import { apiClient } from '../services/apiClient';

export async function fetchEvents(productId: string) {
  try {
    const response = await apiClient.fetch(
      `${AIPDATA_BASE_URL}/v2/event-definitions?productId=${productId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return response.json();
  } catch (error) {
    throw error;
  }
}